import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'

import {
  Table,
  Button,
  FormControl,
  FormGroup,
  ControlLabel,
  Alert,
} from 'react-bootstrap';

import If from "../../utils/If"

import Loader from 'react-loader-advanced';

import '../../statics/css/contracts.css'
import '../../statics/css/util.css'

import { getContract, registerContract } from '../../dao-firebase/contracts-firebase';

class ConsultContract extends Component {

  constructor(props) {
    super(props);

    this.state = {
      load: false,

      messageAll: '',
      messageAllStatus: 'warning',

      form_contract_text: "",

      edtitting: false,

      contract: undefined,

    };

  }

  componentWillMount() {

    this.setState({
      load: true,
    })

    getContract(JSON.parse(localStorage.getItem("USER")).uid, 'consult', (response, success) => {

      //Já existe texto de contrato
      if (success) {

        this.setState({

          form_contract_text: response.text,
          edtitting: false,
          load: false,
          contract: response,

        })

      } else {

        //Nunca foi redigido texto de contrato
        if (response.message = "no") {

          //Erro ao fazer a requisição
          this.setState({

            edtitting: true,
            load: false,
          })

        } else {

          //Erro ao fazer a requisição
          this.setState({

            edtitting: true,
            messageAll: "Erro ao obter contrato: " + response.message,
            messageAllStatus: 'danger',
            load: false,
          })

        }
      }

    })
  }

  onInputChange(target) {

    console.log(target);

    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  saveContract() {


    this.setState({
      load: true,
    })

    if (this.state.form_contract_text != '') {

      //salvando o contrato
      registerContract(JSON.parse(localStorage.getItem("USER")).uid, { text: this.state.form_contract_text }, 'consult', (response, success) => {

        if (success) {

          this.setState({
            load: false,
            messageAll: "Contrato de Consultoria atualizado com sucesso!",
            messageAllStatus: "success",
            edtitting: false,
            contract: response,
          })

          setTimeout(() => {

            if (this.state.messageAll == "Contrato de Consultoria atualizado com sucesso!") {
              this.setState({
                messageAll: '',
              });
            }
          }, 5000);

        } else {
          this.setState({
            load: false,
            messageAll: "Falha ao salvar o contrato: " + response.message,
            messageAllStatus: "danger",
            edtitting: true,
          })
        }

      })

    } else {
      this.setState({
        load: false,
        messageAll: "Insira um texto para o contrato",
        edtitting: true,
      })
    }
  }

  renderMessage(message) {
    return (
      <p>
        <strong>{message.substring(0, message.indexOf(" "))}</strong>
        {message.substring(message.indexOf(" "))}
      </p>
    )
  }

  convertDate(date) {

    let convertedDate = new Date(date * 1000).toLocaleDateString("pt-BR");
    return convertedDate;
  }

  editContract() {
    this.setState({
      edtitting: true,
    })
  }

  render() {

    return (
      <Loader show={this.state.load} message={<div className="loader"></div>}
        backgroundStyle={{ backgroundColor: 'none' }}
        foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>
        <div className="contracts-page">

          {this.state.messageAll && this.state.messageAll != '' ?
            <Alert bsStyle={!this.state.messageAllStatus || this.state.messageAllStatus == '' ? 'warning' : this.state.messageAllStatus}>
              {this.renderMessage(this.state.messageAll)}
            </Alert>
            : null}


          <div className="label-more-button-top">
            <h1 className="label-table">Contrato de Consultoria Esportiva</h1>
            {/* <div className="actions-submit-training"> */}
            <div className="actions-submit-contract">

              <div className="update-label-button-div">
                <If test={(this.state.contract && this.state.contract.date_create)}>
                  <p className="secondaryFontColor">Atualizado em {(this.state.contract != undefined && this.state.contract.date_create) ? this.convertDate(this.state.contract.date_create.seconds) : null}</p>
                </If>
                {this.state.edtitting ?

                  <Button bsStyle="primary" onClick={() => this.saveContract()}>Salvar contrato</Button>
                  :
                  <Button bsStyle="warning" onClick={() => this.editContract()}>Editar</Button>

                }
              </div>

            </div>
          </div>

          <FormGroup controlId="formControlsDescriptionTraining">
            <ControlLabel>Texto contratual</ControlLabel>

            <If test={this.state.edtitting}>
              <FormControl
                rows="10"
                componentClass="textarea"
                name="form_contract_text"
                type="text"
                className="textarea-fixed"
                value={this.state.form_contract_text}
                placeholder="Insira o texto"
                onChange={(event) => this.onInputChange(event.target)} />
            </If>

            <If test={!this.state.edtitting}>
              <div className="background-and-padding">

                <p>{this.state.form_contract_text}</p>
              </div>

            </If>

          </FormGroup>


        </div>
      </Loader >
    );
  }
}

export default ConsultContract;



// WEBPACK FOOTER //
// src/components/contracts/consult-contract.js